/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SensorUnitDto } from './sensorUnitDto';


export interface SensorUnitDimensionDto { 
    type: SensorUnitDimensionDto.TypeEnum;
    units: Array<SensorUnitDto>;
}
export namespace SensorUnitDimensionDto {
    export type TypeEnum = 'TEMPERATURE' | 'ENERGY' | 'POWER' | 'VOLUME' | 'VOLUME_FLOW' | 'PRESSURE' | 'FRACTION' | 'VOLTAGE' | 'CURRENT' | 'FREQUENCY' | 'NONE';
    export const TypeEnum = {
        Temperature: 'TEMPERATURE' as TypeEnum,
        Energy: 'ENERGY' as TypeEnum,
        Power: 'POWER' as TypeEnum,
        Volume: 'VOLUME' as TypeEnum,
        VolumeFlow: 'VOLUME_FLOW' as TypeEnum,
        Pressure: 'PRESSURE' as TypeEnum,
        Fraction: 'FRACTION' as TypeEnum,
        Voltage: 'VOLTAGE' as TypeEnum,
        Current: 'CURRENT' as TypeEnum,
        Frequency: 'FREQUENCY' as TypeEnum,
        None: 'NONE' as TypeEnum
    };
}


